import { IonPage } from '@ionic/react';

import {
	AdminActionDateRangeLookup,
	AdminActionDocumentTypeLookup,
	AdminActionFilterParamType,
	AdminActionSortByLookup,
	AdminActionsTakenLookup,
	dateDiffDays,
	ReportReasonsFilterLookup
} from 'model';

import { useState } from 'react';
import { FormSelectBox } from '../../components/Forms/FormSelectBox';
import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { IconArrowBack, IconCheck } from '../../components/QuirkIcons';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { FormValueType } from '../../hooks/useFormValues';
import { useUserHasRole } from '../../hooks/useUserHasRole';
import { getDaysBackRange } from '../../util/getDaysBackRange';
import { AdminOnly } from './AdminOnly';
import styles from './ReportFilters.module.css';

export const ReportFilters: React.FC<{
	setValues: (value: FormValueType<AdminActionFilterParamType>) => void;
	reportFilterValues: AdminActionFilterParamType;
	onDismiss: () => {};
}> = ({ onDismiss, setValues, reportFilterValues }) => {
	const admin = useUserHasRole('admin');
	const [dateValue, setDateValue] = useState<string | undefined>(
		reportFilterValues.dateRange
			? String(Math.floor(dateDiffDays(reportFilterValues.dateRange[0], reportFilterValues.dateRange[1])))
			: '7'
	);
	const convertDate = (value: FormValueType<{ dateRange: string }>) => {
		if (value.dateRange) {
			setDateValue(String(value.dateRange));
			setValues({ dateRange: getDaysBackRange(value.dateRange) });
		}
	};
	return (
		<IonPage>
			<Header
				title="Reports Filter"
				left={<IconButton icon={<IconArrowBack />} onClick={() => onDismiss()} />}
				right={
					admin ? <IconButton label="Apply" icon={<IconCheck />} onClick={() => onDismiss()} /> : <div></div>
				}
			/>
			<QuirkIonContent>
				<AdminOnly>
					<div>
						<div className={styles.filterOptionsContainer}>
							<div className={styles.filterRowContainer}>
								<FormSelectBox
									id="sortBy"
									setValues={setValues}
									field={{
										value: reportFilterValues.sortBy as string,
										errors: []
									}}
									label="Sort By"
									options={AdminActionSortByLookup}
								/>
								<FormSelectBox
									id="documentType"
									setValues={setValues}
									field={{
										value: reportFilterValues.documentType as string,
										errors: []
									}}
									label="Type"
									options={AdminActionDocumentTypeLookup}
								/>
							</div>
							<FormSelectBox
								id="dateRange"
								setValues={convertDate}
								field={{
									value: dateValue as string,
									errors: []
								}}
								label="Date Range"
								options={AdminActionDateRangeLookup}
							/>
							<FormSelectBox
								id="actionTaken"
								setValues={setValues}
								field={{
									value: reportFilterValues.actionTaken as string,
									errors: []
								}}
								label="Action Taken"
								options={AdminActionsTakenLookup}
							/>
							<FormSelectBox
								id="reason"
								setValues={setValues}
								field={{
									value: reportFilterValues.reason as string,
									errors: []
								}}
								label="Reason"
								options={ReportReasonsFilterLookup}
							/>
						</div>
					</div>
				</AdminOnly>
			</QuirkIonContent>
		</IonPage>
	);
};
